import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useWaitlistCount(refreshKey = 0) {
  const [count, setCount] = useState(null);
  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/waitlist/count`, { timeout: 6000 })
      .then((r) => {
        if (!cancelled) setCount(r.data?.count ?? null);
      })
      .catch(() => {
        if (!cancelled) setCount(null);
      });
    return () => {
      cancelled = true;
    };
  }, [refreshKey]);
  return count;
}

export function useDetectedCity() {
  const [city, setCity] = useState(null);
  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/geo`, { timeout: 6000 })
      .then((r) => {
        const c = r.data?.city;
        const cc = r.data?.country_code;
        if (!cancelled && c && typeof c === "string" && cc === "FR") setCity(c);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);
  return city;
}
